export default __webpack_public_path__ + "static/media/Deathsong.3dfff4a3.jpg";